import { MyHttpClient } from '../http-client.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "../http-client.service";
var CustomerInvoiceDetailsService = /** @class */ (function () {
    function CustomerInvoiceDetailsService(http) {
        this.http = http;
        this.server = environment.server;
        this.invoiceDetailsUrl = this.server + '/api/getInvoiceDetails';
        this.sendInvoiceUrl = this.server + '/api/sendInvoice';
        this.dashboardInvoiceReceiptUrl = this.server + '/api/dashboard/bill';
    }
    CustomerInvoiceDetailsService.prototype.fetchInvoiceDetails = function (orderId) {
        var url = this.invoiceDetailsUrl + "/" + orderId;
        var body = {
            orderId: orderId,
        };
        return this.http.post(url, body).pipe(catchError(this.handleError));
    };
    CustomerInvoiceDetailsService.prototype.fetchDashboardInvoiceOrReceipt = function (orderId) {
        var url = this.dashboardInvoiceReceiptUrl + "?orderId=" + orderId;
        return this.http.get(url).pipe(catchError(this.handleError));
    };
    CustomerInvoiceDetailsService.prototype.sendInvoiceToEmail = function (email, orderId, userId) {
        var url = "" + this.sendInvoiceUrl;
        if (email) {
            url = url + "?email=" + email;
        }
        var body = {
            email: email,
            orderId: orderId,
            userId: userId
        };
        return this.http.post(url, body).pipe(catchError(this.handleError));
    };
    CustomerInvoiceDetailsService.prototype.handleError = function (error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error("Backend returned code " + error.status + ", " +
                ("body was: " + error.error));
        }
        // return an observable with a user-facing error message
        return throwError(error);
    };
    CustomerInvoiceDetailsService.ngInjectableDef = i0.defineInjectable({ factory: function CustomerInvoiceDetailsService_Factory() { return new CustomerInvoiceDetailsService(i0.inject(i1.MyHttpClient)); }, token: CustomerInvoiceDetailsService, providedIn: "root" });
    return CustomerInvoiceDetailsService;
}());
export { CustomerInvoiceDetailsService };
